module.exports = __webpack_public_path__ + "img/album14_20.5422ca40.jpg";